import MuiButton, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { forwardRef, Ref } from 'react';

const Button = (
  props: ButtonProps & {
    icon?: boolean;
    customVariant?: 'text-small';
    'aria-label': string;
    role?: string;
  },
  ref: Ref<HTMLButtonElement>,
) => {
  return (
    <StyledButton
      {...props}
      customVariant={props.customVariant}
      ref={ref}
      aria-label={props['aria-label']}
      role={props.role || 'button'}
    />
  );
};

const StyledButton = styled(MuiButton, {
  shouldForwardProp: (prop) =>
    prop !== 'icon' && prop !== 'customVariant',
})<{
  icon?: boolean;
  disabled?: boolean;
  textSmall?: boolean;
  customVariant?: 'text-small';
  loading?: boolean | null;
}>(
  ({
    theme,
    variant,
    icon = false,
    disabled,
    customVariant,
    loading,
  }) => {
    let color = theme.palette.white;
    let iconColor = theme.palette.primary.main;
    let fontWeight = 600;
    let lineHeight: string | number = 1.75;
    let height = 40;

    if (loading) {
      iconColor = 'transparent';
    } else if (disabled) {
      iconColor = '#00000042';
    } else if (variant === 'contained') {
      iconColor = theme.palette.white;
    } else if (variant === 'text') {
      iconColor = theme.palette.textPrimaryBlack;
    }

    if (customVariant === 'text-small') {
      fontWeight = 500;
      lineHeight = '20px';
      height = 32;
    }

    if (variant === 'text' && customVariant === 'text-small') {
      color = theme.palette.primary.main;
    } else if (variant === 'text' || !variant) {
      color = theme.palette.textPrimaryBlack;
    } else if (variant === 'outlined') {
      color = theme.palette.primary.main;
    }

    return {
      transition: 'all 0.2s ease-in-out',
      height,
      minWidth: height,
      borderRadius: theme.radii.sm,
      boxShadow: 'none',
      textTransform: 'none',
      fontWeight,
      lineHeight,
      gap: theme.spacing(1),
      padding: icon ? '10px' : '5px 15px',
      color,

      path: {
        transition: 'all 0.2s ease-in-out',
        stroke: iconColor,
      },
    };
  },
);

export default forwardRef(Button);
